// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_AcessoPortalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /clientes/acesso-portal/{cliente_id}
 *
 * Current portal-account state for one cliente, so the staff SPA can decide
 * between offering "create access" and showing what already exists.
 *
 * Never carries the activation code and never a password hash: this is a read
 * that staff may run repeatedly, and a read that hands out a credential is a
 * way to take over an account. Re-issuing is an explicit, separate action.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_AcessoPortalResponseDados {
cliente_id: number
document: string
exists: boolean
status?: string
created_at?: string
activated_at?: string
credential_expires_at?: string
last_seen_at?: string
blocked_until?: string
push_devices?: number
}

export type Clientes_AcessoPortalResponse = ApiResponse<Clientes_AcessoPortalResponseDados>;

registerResponseContract('Clientes_AcessoPortalResponse', {
  cliente_id:            { type: 'number',  required: true },
  document:              { type: 'string',  required: true },
  exists:                { type: 'boolean', required: true },
  status:                { type: 'string',  required: false },
  created_at:            { type: 'string',  required: false },
  activated_at:          { type: 'string',  required: false },
  credential_expires_at: { type: 'string',  required: false },
  last_seen_at:          { type: 'string',  required: false },
  blocked_until:         { type: 'string',  required: false },
  push_devices:          { type: 'number',  required: false },
})
